<template>
  <v-app class="app-background-print" v-loading.fullscreen.lock="auth.isLoading" style="text-transform: uppercase;">
    <el-row type="flex" style="height: 53px; border-bottom: 1px solid black">
      <div style="width: 153px;
        height: 53px;
        border-right: 1px solid black;
        display: flex;
        justify-content: center;
        align-items: center">
        <el-image
          style="width: 50px; height: 50px"
          src="https://fastratabuana.co.id/themes/fastra-buana/assets/images/main/fastrata_logo.png"
          fit="fill"></el-image>
      </div>
      <div
        style="width: 575px; 
        height: 53px;
        display: flex;
        justify-content: center;
        align-items: center;
        "
      >
        <h3>FORM PENDATAAN PELANGGAN BARU (FPP)</h3>
      </div>
      <div
        style="width: 270px;
        height: 53px;
        border-left: 1px solid black;
        "
      >
      <div style="display: flex; height: 16px; align-items: center">
        <p style="margin: 0 30px 0 0; font-size: 8px; font-weight: bold">CABANG</p> 
        <p style="margin: 0; font-size: 8px"> : &nbsp; </p> 
        <input type="text" name="cabang" id="cabang" 
        style="
        border: 1px solid black;
        width: 122px;
        height: 13px;">
      </div>
      <div style="display: flex; height: 16px; align-items: center">
        <p style="margin: 0 14px 0 0; font-size: 8px; font-weight: bold">WIL / SP / FS</p> 
        <p style="margin: 0; font-size: 8px"> : &nbsp; </p> 
        <input type="text" name="sp" id="sp" 
        style="
        border: 1px solid black;
        width: 122px;
        height: 13px;">
      </div>
      <div style="display: flex; height: 16px; align-items: center">
        <p style="margin: 0 26px 0 0; font-size: 8px; font-weight: bold">TANGGAL</p> 
        <p style="margin: 0; font-size: 8px"> : &nbsp; </p> 
        <input type="text" name="tanggal" id="tanggal" 
        style="
        border: 1px solid black;
        width: 122px;
        height: 13px;">
      </div>
      
      </div>
    </el-row>

    <el-row style="border-bottom: 1px solid black;">
      <h3 style="margin-left: 20px">DIISI OLEH PELANGGAN</h3>
    </el-row>
    <div style="display: flex; font-style: italic; height: 20px; font-size: 10px;">
      <h4 style="margin-left: 10px">Petunjuk Pengisian : </h4>
      <p style="position: relative; padding-left: 20px; margin-left: 10px;"><span style="font-size: 10px; position: absolute; top: 0; left: 0;">a)</span> Pengisian menggunakan huruf kapital</p>
      <p style="position: relative; padding-left: 20px; margin-left: 10px;"><span style="font-size: 10px; position: absolute; top: 0; left: 0;">b)</span> Lingkari pilihan yang sesuai</p>
      <p style="position: relative; padding-left: 20px; margin-left: 10px;"><span style="font-size: 10px; position: absolute; top: 0; left: 0;">c)</span> Beri tanda silang (x) pada kolom pilihan</p>
      <p style="position: relative; padding-left: 20px; margin-left: 10px;"><span style="font-size: 10px; position: absolute; top: 0; left: 0;">d)</span> Coret yang tidak perlu</p>
    </div>
    <ol style="font-size: 11px;">    
      <!-- <li v-for="item in payloadPelanggan" :key="item.label">
        <div style="display: flex">
          <p style="margin: 0; width: 210px; font-weight: bold">{{ item.label }}</p>
          <p style="margin: 0; border-bottom: 1px solid black; width: 456px"> : {{ getWord($route.params.customerNew, item.key, "-") }}</p>
        </div>
        <ol>
            <li v-for="subItem in item.subItem" :key="subItem.label">
              <div style="display: flex">
                <p style="margin: 0; width: 185px; font-weight: bold">{{ subItem.label }}</p>
                <p style="margin: 0; border-bottom: 1px solid black; width: 460px"> : {{ getWord($route.params.customerNew, subItem.key, "-") }}</p>
              </div>
            </li>
          </ol>
      </li> -->
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NAMA PERUSAHAAN/OUTLET<span style="font-size: 8px; position: absolute; top: 0; right:0;">a)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 33" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.company_name.charAt(index-1) }}</p>
        </div>
        <!-- <ol>
            <li>
              <div style="display: flex">
                <p style="margin: 0; width: 185px; font-weight: bold">{{ subItem.label }}</p>
                <p style="margin: 0; border-bottom: 1px solid black; width: 460px"> : {{ getWord($route.params.customerNew, subItem.key, "-") }}</p>
              </div>
            </li>
          </ol> -->
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">FAMILIAR OUTLET NAME<span style="font-size: 8px; position: absolute; top: 0; right: 25px;">a)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 23" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.owner.charAt(index-1) }}</p>
          <p style="position: relative; padding-left: 0px; margin-left: 10px; font-style: italic;">(diisi untuk outlet modern market)</p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">GROUP ACCOUNT<span style="font-size: 8px; position: absolute; top: 0; right: 60px;">a)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 23" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.owner.charAt(index-1) }}</p>
          <p style="position: relative; padding-left: 0px; margin-left: 10px; font-style: italic;">(diisi untuk outlet modern market)</p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">BENTUK BADAN USAHA<span style="font-size: 8px; position: absolute; top: 0; right: 30px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity.toUpperCase() === "PT" ? "x" : ""}}</p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">PT</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity.toUpperCase() === "CV" ? "x" : ""}}</p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">CV</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity.toUpperCase() === "PERORANGAN" ? "x" : ""}}</p>
          <p style="margin-left: 5px; width: 90px; font-weight: bold;">PERORANGAN</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity.toUpperCase() === "PD" ? "x" : ""}}</p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">PD</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity.toUpperCase() === "UD" ? "x" : ""}}</p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">UD</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity.toUpperCase() === "KOPERASI" ? "x" : ""}}</p>
          <p style="margin-left: 5px; width:80px; font-weight: bold;">KOPERASI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bussines_entity && ($route.params.customerNew.bussines_entity.toUpperCase() === "OTHER" || !['PT','CV','PERORANGAN','PD','UD','KOPERASI'].includes($route.params.customerNew.bussines_entity.toUpperCase())) ? "x" : ""}}</p>
          <p style="margin-left: 5px; width: 100px; font-weight: bold;">{{ $route.params.customerNew.bussines_entity && ($route.params.customerNew.bussines_entity.toUpperCase() === "OTHER" || !['PT','CV','PERORANGAN','PD','UD','KOPERASI'].includes($route.params.customerNew.bussines_entity.toUpperCase())) ? "DLL : " + $route.params.customerNew.bussines_entity.toUpperCase() : "DLL : .................." }}</p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NO. NPWP.</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.npwp.charAt(index-1) }}</p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">ALAMAT BILL TO <span style="font-size: 8px; position: absolute; top: 0; right: 65px;">a)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.address.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">(ALAMAT SESUAI NPWP)</p>
          <span style="margin-left: 12px; margin-right: 10px;"></span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.address.charAt(index+35) }}</p>
        </div>
        <div style="display: flex; height: 20px;margin-left: 180px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;">KELURAHAN</p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.village.charAt(index-1) }}</p>
          <p style="margin-left: 10px; width: 70px; font-weight: bold; position: relative;">KECAMATAN</p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.district.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;margin-left: 180px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;">KODYA/KAB. <span style="font-size: 8px; position: absolute; top: 0; right: 0;">d)</span></p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.district.charAt(index-1) }}</p>
          <p style="margin-left: 10px; width: 70px; font-weight: bold; position: relative;">KOTA</p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.district.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;margin-left: 180px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;">PROPINSI</p>
          <p v-for="index in 21" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.province.charAt(index-1) }}</p>
          <p style="margin-left: 10px; width: 70px; font-weight: bold; position: relative;">KODE POS</p>
          <p v-for="index in 5" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.bill_to.postal_code.charAt(index-1) }}</p>
        </div>
      </li>
      <li style="margin-top: 80px;">
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">ALAMAT SHIP TO <span style="font-size: 8px; position: absolute; top: 0; right: 65px;">a)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.address.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">(ALAMAT KIRIM)</p>
          <span style="margin-left: 12px; margin-right: 10px;"></span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.address.charAt(index+35) }}</p>
        </div>
        <div style="display: flex; height: 20px;margin-left: 180px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;">KELURAHAN</p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.village.charAt(index-1) }}</p>
          <p style="margin-left: 10px; width: 70px; font-weight: bold; position: relative;">KECAMATAN</p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.district.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;margin-left: 180px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;">KODYA/KAB. <span style="font-size: 8px; position: absolute; top: 0; right: 0;">d)</span></p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.district.charAt(index-1) }}</p>
          <p style="margin-left: 10px; width: 70px; font-weight: bold; position: relative;">KOTA</p>
          <p v-for="index in 13" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.district.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;margin-left: 180px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;">PROPINSI</p>
          <p v-for="index in 21" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.province.charAt(index-1) }}</p>
          <p style="margin-left: 10px; width: 70px; font-weight: bold; position: relative;">KODE POS</p>
          <p v-for="index in 5" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.ship_to.postal_code.charAt(index-1) }}</p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NAMA LENGKAP</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.owner.charAt(index-1) }}</p>
        </div>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">(SESUAI NIK / PASSPORT)</p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NO. NIK / PASSPORT</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.nik.charAt(index-1) }}</p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NOMOR TELEPON</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="margin: 0; width: 45px; font-weight: bold; position: relative;">RUMAH</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color: darkgray;">6</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color:darkgray">2</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 3" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index-1) }}</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 9" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index+2) }}</p>
        </div>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;"></p>
          <span style="margin-left: 10px; margin-right: 13px;"></span>
          <p style="margin: 0; width: 45px; font-weight: bold; position: relative;">TOKO</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color: darkgray;">6</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color:darkgray">2</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 3" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index-1) }}</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 9" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index+2) }}</p>
          <p style="margin: 0; width: 25px; font-weight: bold; position: relative;">FAX</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color: darkgray;">6</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color:darkgray">2</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 3" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index-1) }}</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 9" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index+2) }}</p>
        </div>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;"></p>
          <span style="margin-left: 10px; margin-right: 13px;"></span>
          <p style="margin: 0; width: 45px; font-weight: bold; position: relative;">HP</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color: darkgray;">6</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color:darkgray">2</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 3" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index-1) }}</p>
          <p style="margin: 0; margin: 0 5px; font-weight: bold; position: relative;">-</p>
          <p v-for="index in 9" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.tlp.charAt(index+2) }}</p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">ALAMAT EMAIL <span style="font-size: 8px; position: absolute; top: 0; right: 70px;">a)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;">{{ $route.params.customerNew.email_address.charAt(index-1) }}</p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">JENIS USAHA</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NAMA PEMILIK <span style="font-size: 8px; position: absolute; top: 0; right: 70px;">a)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NAMA SUAMI / ISTRI <span style="font-size: 8px; position: absolute; top: 0; right: 45px;">d)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">TANGGAL LAHIR PEMILIK <span style="font-size: 8px; position: absolute; top: 0; right: 45px;">d)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 2" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <span style="margin-left: 8px; margin-right: 8px;">-</span>
          <p v-for="index in 9" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <span style="margin-left: 8px; margin-right: 8px;">-</span>
          <p v-for="index in 4" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">STATUS OUTLET<span style="font-size: 8px; position: absolute; top: 0; right: 65px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 90px; font-weight: bold;">MILIK SENDIRI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">KONTRAK</p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">JADWAL OPERASIONAL OUTLET</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="width: 70px; font-weight: bold;">JAM BUKA 1</p>
          <p v-for="index in 5" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgray;"></p>
          <p style="margin-left: 5px; width: 70px; font-weight: bold;">JAM TUTUP 1</p>
          <p v-for="index in 5" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgray;"></p>
          <p style="margin-left: 5px;width: 70px; font-weight: bold;">HARI LIBUR</p>
          <p v-for="index in 10" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgray;"></p>
        </div>
        <div style="display: flex; margin-left: 3px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;"></p>
          <span style="margin-left: 10px; margin-right: 10px;"></span>
          <p style="width: 70px; font-weight: bold;">JAM BUKA 2</p>
          <p v-for="index in 5" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgray;"></p>
          <p style="margin-left: 5px; width: 70px; font-weight: bold;">JAM TUTUP 2</p>
          <p v-for="index in 5" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgray;"></p>
          </div>
      </li>
      <li style="height: 20px;margin-top: 25px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">KENDARAAN YANG BISA AKSES<span style="font-size: 8px; position: absolute; top: 0; right: 30px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; background-color: lightgrey;"></p>
          <p style="margin-left: 5px; width: 45px; font-weight: bold;">MOTOR</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgrey"></p>
          <p style="margin-left: 5px; width: 80px; font-weight: bold;">MOTOR DEMO</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgrey"></p>
          <p style="margin-left: 5px; width: 40px; font-weight: bold;">L300</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgrey"></p>
          <p style="margin-left: 5px; width: 45px; font-weight: bold;">ENGKLE</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgrey"></p>
          <p style="margin-left: 5px; width: 45px; font-weight: bold;">DOUBLE</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgrey"></p>
          <p style="margin-left: 5px; width:40px; font-weight: bold;">FUSO</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;background-color: lightgrey"></p>
          <p style="margin-left: 5px; width: 100px; font-weight: bold;">WINGBOX</p>
        </div>
      </li>
      <li style="height: 20px;margin-top: 15px;">
        <div style="display: flex;height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">PEMBAYARAN<span style="font-size: 8px; position: absolute; top: 0; right: 80px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 100px; font-weight: bold;">TUNAI / TRANSFER</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 120px; font-weight: bold;">CHEQUE/GIRO, BANK :</p>
          <p v-for="index in 18" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
        <div style="display: flex; margin-left: 143px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">
          </p>
          <span style="margin-left: 10px; margin-right: 10px;"></span>
          <p style="margin-left: 5px; width: 100px; font-weight: bold;">NO.REK</p>
          <span style="margin-left: 9px;margin-right: 9px"> :</span>
          <p v-for="index in 18" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li style="margin-top: 20px;">
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">PENANGGUNG JAWAB / PEMILIK</p>
        </div>
        <div style="display: flex; height: 10px;margin-top: 15px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">- NAMA</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
        <div style="display: flex;margin-top: 15px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">- JABATAN</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 35" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li>
        <table class="tablePrintCustomerNew">
      <tr>
        <th style="width: 201px;">STEMPEL TOKO</th>
        <th colspan="4" style="width: 649px;">TANDA TANGAN PELANGGAN</th>
      </tr>
      <tr>
        <th rowspan="3"></th>
        <th>SPECIMEN 1</th>
        <th>SPECIMEN 2</th>
        <th>SPECIMEN 3</th>
        <th>SPECIMEN 4</th>
      </tr>
      <tr align="left">
        <th style="height: 64px; vertical-align: bottom;">Tgl.</th>
        <th style="height: 64px; vertical-align: bottom;">Tgl.</th>
        <th style="height: 64px; vertical-align: bottom;">Tgl.</th>
        <th style="height: 64px; vertical-align: bottom;">Tgl.</th>
      </tr>
      <tr align="left" style="font-size: 8px;">
        <th>NAMA:</th>
        <th>NAMA:</th>
        <th>NAMA:</th>
        <th>NAMA:</th>
      </tr>
    </table>
      </li>
    </ol>    


    <el-row style="
      border-bottom: 1px solid black;
      border-top: 1px solid black;
      margin: 10px 0">
      <h3 style="margin-left: 20px">DIISI OLEH PERUSAHAN</h3>
    </el-row>

    <ol start="22" style="font-size: 11px;">
      <!-- <li v-for="item in payloadPerusahaan" :key="item.label">
        <div style="display: flex">
          <p style="margin: 0; width: 210px; font-weight: bold">{{ item.label }}</p>
          <p style="margin: 0; border-bottom: 1px solid black; width: 456px"> : {{ getWord($route.params.customerNew, item.key, "-") }}</p>
        </div>
        <ol>
            <li v-for="subItem in item.subItem" :key="subItem.label">
              <div style="display: flex">
                <p style="margin: 0; width: 185px; font-weight: bold">{{ subItem.label }}</p>
                <p style="margin: 0; border-bottom: 1px solid black; width: 460px"> : {{ getWord($route.params.customerNew, subItem.key, "-") }}</p>
              </div>
            </li>
          </ol>
      </li> -->
      <li style="height: 20px;margin-top: 25px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">KEPUTUSAN MANAJEMEN<span style="font-size: 8px; position: absolute; top: 0; right: 15px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">DITERIMA</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">DITOLAK</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">DITUNDA</p>
          <p style="margin: 0; width: 85px; font-weight: bold; position: relative;">KATEGORI NOA<span style="font-size: 8px; position: absolute; top: 0; right: 0px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">REGISTER</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">UNREGISTER</p>
        </div>
      </li>
      <li>
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NO. FAKTUR TRANSAKSI PERTAMA</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 25" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li>
        <div style="display: flex;height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">MARKET PLACE<span style="font-size: 8px; position: absolute; top: 0; right: 70px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">AMC</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">LKS</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">BND</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">BKL</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">DPR</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">JL1</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">JL2</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">JL3</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">JL4</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">LPR</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">PBR</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">STK</p>
        </div>
        <div style="display: flex;margin-left: 3px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">
          </p>
          <span style="margin-left: 10px; margin-right: 10px;"></span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">PLB</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">PNP</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">PBJ</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">PKT</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">SOV</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">SPB</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">TIB</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">TOR</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">TPJ</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">TSK</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">BUS</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width:30px; font-weight: bold;">RSK</p>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex;height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">CUSTOMER TYPE CHANNEL<span style="font-size: 8px; position: absolute; top: 0; right: 10px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">NKA</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">LKA</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold;">MTA</p>
          <span style="margin-left: 10px; margin-right: 10px;font-style: italic;">(diisi untuk outlet modern market)</span>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">OUTLET MM CLASSIFICATION<span style="font-size: 8px; position: absolute; top: 0; right: 0px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">REGULAR</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">PREMIUM</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">SPECIAL</p>
          <span style="margin-left: 10px; margin-right: 10px;font-style: italic;">(diisi untuk outlet modern market)</span>
        </div>
      </li>
      <div style="display: flex; height: 20px; margin-left: 182px;">
        <p style="border: 1px solid black; width: 192px; height: 18px; text-align: left; font-weight: bold;">Kode Salesman 1</p>
        <p style="border: 1px solid black; width: 192px; height: 18px; text-align: left; font-weight: bold">Kode Salesman 2</p>
        <p style="border: 1px solid black; width: 192px; height: 18px; text-align: left; font-weight: bold">Kode Salesman 3</p>
      </div>
      <li style="height:38px">
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">TYPE OUTLET<span style="font-size: 8px; position: absolute; top: 0; right: 80px;">b)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">BG</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">GR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SG</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">RT</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">KR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">WT</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">WK</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">IS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">ES</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">HS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">FS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">BG</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">GR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SG</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">RT</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">KR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">WT</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">WK</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">IS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">ES</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">HS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">FS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">BG</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">GR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SG</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">RT</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">KR</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">WT</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">WK</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">IS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">ES</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">HS</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">FS</p>
        </div>
        <div style="display: flex; margin-left: 182px;">
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">HM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">MM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SP</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">DC</p>
          <div style="background-color: black;width: 112px;height: 16px;">
          </div>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">HM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">MM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SP</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">DC</p>
          <div style="background-color: black;width: 112px;height: 16px;">
          </div>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">HM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">MM</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SP</p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">DC</p>
          <div style="background-color: black;width: 112px;height: 16px;">
          </div>
        </div>
      </li>
      <li style="height :20px">
        <div style="display: flex; ">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">JENIS OUTLET<span style="font-size: 8px; position: absolute; top: 0; right: 80px;">b)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">C</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">S</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">B</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">F</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">P</p>
          <div style="background-color: black;width: 32px;height: 16px;">
          </div>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">C</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">S</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">B</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">F</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">P</p>
          <div style="background-color: black;width: 32px;height: 16px;">
          </div>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">C</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">S</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">B</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">F</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">P</p>
          <div style="background-color: black;width: 32px;height: 16px;">
          </div>
        </div>
      </li>
      <li>
        <div style="display: flex; height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">TYPE SALESMAN<span style="font-size: 8px; position: absolute; top: 0; right: 65px;">b)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEA</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEC</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SES</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEP</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRA</p>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEA</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEC</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SES</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEP</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRA</p>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEA</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEC</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SES</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SEP</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRA</p>
          
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">
          </p>
          <span style="margin-left: 12px; margin-right: 10px;"></span>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRC</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRS</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCA</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCR</p>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRC</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRS</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCA</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCR</p>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRC</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRS</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SRB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCA</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCB</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SCR</p>
          
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">
          </p>
          <span style="margin-left: 12px; margin-right: 10px;"></span>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SMP</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">TVS</p>
          <div style="background-color: black;width: 128px;height: 16px;">
          </div>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SMP</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">TVS</p>
          <div style="background-color: black;width: 128px;height: 16px;">
          </div>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">SMP</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 10px;">TVS</p>
          <div style="background-color: black;width: 128px;height: 16px;">
          </div>
        </div>
      </li>
      <li>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">WILAYAH PENJUALAN <span style="margin-left: 20px;">FC</span><span style="font-size: 8px; position: absolute; top: 0; right: 2px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M1</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2C13</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2C24</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M3</p>
          <div style="background-color: black;width: 32px;height: 16px;"></div>
          
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M1</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2C13</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2C24</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M3</p>
          <div style="background-color: black;width: 32px;height: 16px;"></div>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M1</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2C13</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2C24</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M2</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M3</p>
          <div style="background-color: black;width: 32px;height: 16px;"></div>
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">
          </p>
          <span style="margin-left: 12px; margin-right: 10px;"></span>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M4</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C14</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C25</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C36</p>
          <div style="background-color: black;width: 32px;height: 16px;"></div>
          <div style="background-color: black;width: 32px;height: 16px;"></div>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M4</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C14</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C25</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C36</p>
          <div style="background-color: black;width: 32px;height: 16px;"></div>
          <div style="background-color: black;width: 32px;height: 16px;"></div>

          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">M4</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C14</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C25</p>
          <p style="border: 1px solid black; width: 32px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;">H3C36</p>
          <div style="background-color: black;width: 32px;height: 16px;"></div>
          <div style="background-color: black;width: 32px;height: 16px;"></div>
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin-left: 100px; width: 60px; font-weight: bold; position: relative;">RAYON</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <div style="background-color: black;width: 146px;height: 16px;"></div>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <div style="background-color: black;width: 146px;height: 16px;"></div>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 16px; height: 16px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <div style="background-color: black;width: 146px;height: 16px;"></div>
        </div>
      </li>
      <li style="height: 20px;">
        <div style="display: flex">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">PEMBAYARAN<span style="font-size: 8px; position: absolute; top: 0; right: 80px;">c)</span>
          </p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">TUNAI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 5px; width: 60px; font-weight: bold;">KREDIT</p>
        </div>
      </li>

      <li>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 120px; font-weight: bold; position: relative;">TOP & LIMIT KREDIT</p>
          <p style="margin: 0; width: 40px; font-weight: bold; position: relative;">COFFEE <span style="font-size: 8px; position: absolute; top: 0; right: -8px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">GIRO,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 50px; font-weight: bold; position: relative;">HARI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">NET,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">HARI</p>
          <p style="margin-left: 5px; width: 80px; font-weight: bold; position: relative;">LIMIT KREDIT:</p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 120px; font-weight: bold; position: relative;"></p>
          <p style="margin: 0; width: 40px; font-weight: bold; position: relative;">SNACK <span style="font-size: 8px; position: absolute; top: 0; right: -8px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">GIRO,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 50px; font-weight: bold; position: relative;">HARI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">NET,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">HARI</p>
          <p style="margin-left: 5px; width: 80px; font-weight: bold; position: relative;">LIMIT KREDIT:</p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 100px; font-weight: bold; position: relative;"></p>
          <p style="margin: 0; width: 60px; font-weight: bold; position: relative;">BEVERAGE <span style="font-size: 8px; position: absolute; top: 0; right: -8px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">GIRO,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 50px; font-weight: bold; position: relative;">HARI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">NET,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">HARI</p>
          <p style="margin-left: 5px; width: 80px; font-weight: bold; position: relative;">LIMIT KREDIT:</p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 130px; font-weight: bold; position: relative;"></p>
          <p style="margin: 0; width: 30px; font-weight: bold; position: relative;">FOOD <span style="font-size: 8px; position: absolute; top: 0; right: -8px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">GIRO,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 50px; font-weight: bold; position: relative;">HARI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">NET,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">HARI</p>
          <p style="margin-left: 5px; width: 80px; font-weight: bold; position: relative;">LIMIT KREDIT:</p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 70px; font-weight: bold; position: relative;"></p>
          <p style="margin: 0; width: 90px; font-weight: bold; position: relative;">PERSONAL CARE <span style="font-size: 8px; position: absolute; top: 0; right: -8px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">GIRO,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 50px; font-weight: bold; position: relative;">HARI</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">NET,</p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="border: 1px solid black; width: 18px; height: 18px; text-align: center; font-weight: bold;font-size: 9px;"></p>
          <p style="margin-left: 5px; width: 30px; font-weight: bold; position: relative;">HARI</p>
          <p style="margin-left: 5px; width: 80px; font-weight: bold; position: relative;">LIMIT KREDIT:</p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>

      </li>
      <li>
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">NOMOR KODE PELANGGAN<span style="font-size: 8px; position: absolute; top: 0; right: 14px;">b)</span></p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p v-for="index in 4" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <span style="margin-left: 10px; margin-right: 10px;">-</span>
          <p v-for="index in 7" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 10px; width: 310px; font-weight: bold; position: relative; font-size: 9px">*Ketentuan Pemberian TOP/Limit Kredit dan Persetujuannya, mengacu pada WI-SLS-010 </p>
        </div>
      </li>
      <li style="margin-top: 10px">
        <div style="display: flex;  height: 20px;">
          <p style="margin: 0; width: 160px; font-weight: bold; position: relative;">OUTLET</p>
          <span style="margin-left: 10px; margin-right: 10px;">:</span>
          <p style="margin: 0; width: 30px; font-weight: bold; position: relative;">LAT : </p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
          <p style="margin-left: 10px; width: 40px; font-weight: bold; position: relative;">LONG : </p>
          <p v-for="index in 12" :key="index" style="border: 1px solid black; width: 18px; height: 18px; text-align: center;"></p>
        </div>
      </li>
      <li style="margin-bottom: 10px">
        <table class="tablePrintCustomerNew">
      <tr>
        <th colspan="8" >TANDA TANGAN</th>
      </tr>
      <tr>
        <th>DIAJUKAN OLEH</th>
        <th>DIPERIKSA OLEH</th>
        <th colspan="5">DISETUJUI OLEH</th>
        <th>DIINPUT OLEH</th>
      </tr>
      <tr align="left">
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">SALESMAN : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">SPV SALES : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">SM/BM : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">RGM * : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">NOM * : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">GM * : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">DIREKTUR SALES * : </th>
        <th style="height: 64px; vertical-align: bottom; width: 180px; font-size: 9px">FAA : </th>
      </tr>
      <tr align="left" style="font-size: 8px;">
        <th>Tgl.</th>
        <th>Tgl.</th>
        <th>Tgl.</th>
        <th>Tgl.</th>
        <th>Tgl.</th>
        <th>Tgl.</th>
        <th>Tgl.</th>
        <th>Tgl.</th>
      </tr>
    </table>
      </li>
    </ol>
    <br/>
    
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getValue } from "../../common/getValue";
export default {
  data() {
    return {
      showPassword: false,
      remember: false,
      loading: false,
      alert: {},
      user: {
        nik: "",
        password: ""
      },
      payloadPelanggan: [
        { label: 'NAMA PERUSAHAN/OUTLET', key: 'company_name' },
        { label: 'BENTUK BADAN USAHA', key: 'owner' },
        { label: 'NO. NPWP', key: 'npwp' },
        { label: 'ALAMAT BILL TO', key: 'bill_to.address', subItem: [
          { label: 'KELURAHAN', key: 'bill_to.village' },
          { label: 'KECAMATAN', key: 'bill_to.district' },
          { label: 'KODYA/KAB', key: 'bill_to.district' },
          { label: 'KOTA' },
          { label: 'PROVINSI', key: 'bill_to.province' },
          { label: 'KODE POS', key: 'bill_to.postal_code' },
        ] },
        { label: 'ALAMAT SHIP TO', key: 'ship_to.address', subItem: [
          { label: 'KELURAHAN', key: 'ship_to.village' },
          { label: 'KECAMATAN', key: 'ship_to.district' },
          { label: 'KODYA/KAB', key: 'ship_to.district' },
          { label: 'KOTA' },
          { label: 'PROVINSI', key: 'ship_to.province' },
          { label: 'KODE POS', key: 'ship_to.postal_code' },
        ] },
        { label: 'NAMA LENGKAP', key: 'owner'},
        { label: 'NO. NIK / PASSPORT', key: 'nik'},
        { label: 'NOMOR TELEPON', key: 'tlp', subItem: [
          { label: 'TOKO'},
          { label: 'HP'},
          { label: 'FAX'},
        ] },
        { label: 'ALAMAT EMAIL', key: 'email_address' },
        { label: 'JENIS USAHA', },
        { label: 'NAMA PEMILIK', },
        { label: 'NAMA SUAMI / ISTRI', },
        { label: 'TANGGAL LAHIR PEMILIK', },
        { label: 'STATUS OUTLET', },
        { label: 'JADWAL OPERASIONAL OUTLET', subItem: [
          { label: 'JAM BUKA 1'},
          { label: 'JAM BUKA 2'},
          { label: 'JAM TUTUP 1'},
          { label: 'JAM TUTUP 2'},
          { label: 'HARI LIBUR'},
        ] },
        { label: 'KENDARAAN YANG BISA AKSES', },
        { label: 'PEMBAYARAN', },
        { label: 'PENANGGUNG JAWAB / PEMILIK', subItem: [
          { label: 'NAMA'},
          { label: 'JABATAN'},
        ]},
      ],
      payloadPerusahaan: [
        { label: 'KEPUTUSAN MANAJEMEN' },
        { label: 'NO. FAKTUR TRANSAKSI PERTAMA' },
        { label: 'MARKET PLACE' },
        { label: 'CUSTOMER TYPE CHANNEL' },
        { label: 'OUTLET MM CLASSIFICATION' },
        { label: 'TYPE OUTLET' },
        { label: 'JENIS OUTLET' },
        { label: 'TYPE SALESMAN' },
        { label: 'WILAYAH PENJUALAN' },
        { label: 'PEMBAYARAN' },
        { label: 'TOP & LIMIT KREDIT', subItem: [
          { label: 'COFFEE' },
          { label: 'SNACK' },
          { label: 'BEVERAGE' },
          { label: 'FOOD' },
          { label: 'PERSONAL CARE' },
        ] },
        { label: 'NOMOR KODE PELANGGAN' },
        { label: 'TITIK KOORDINAT OUTLET' },
      ]
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login"
    }),
    async loginUser() {
      this.login(this.user);
    },
    getWord(obj, path) {
      return getValue(obj, path);
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  created() {}
};
</script>

<style>
.app-background-print {
  /* background-image: url("../../assets/pdf.jpeg") !important; */
  /* Full height */
  height: 100% !important;

  /* Center and scale the image nicely */
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid black;
}

.tablePrintCustomerNew {
  border-collapse: collapse;
}
.tablePrintCustomerNew, .tablePrintCustomerNew th, .tablePrintCustomerNew td {
    font-size: 12px;
    margin-top: 13px;
  border: 1px solid black;
}
</style>
